export default {
  SET_ADDITIONS(state, addition) {
    state.additions = addition;
  },
};
